/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  PaymentStatus,
  PaymentStatusState
} from '@/store/interfaces/paymentStatus';
import { RootState } from '@/store/interfaces/rootState';
import paymentStatus from '@/store/types/paymentStatus';
import { httpCommpix } from '@/util/HTTPCommpix';
import { AxiosError, AxiosResponse } from 'axios';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const namespaced = true;

const initialState = (): PaymentStatusState => {
  return {
    paymentStatusList: [],
  };
};

const state: PaymentStatusState = initialState();

const getters: GetterTree<PaymentStatusState, RootState> = {
  [paymentStatus.getters.GET_PAYMENT_STATUS_LIST]: state => {
    return state.paymentStatusList;
  },
};

const mutations: MutationTree<PaymentStatusState> = {
  reset: (state: any) => {
    const initialStateFields: any = initialState();
    Object.keys(initialStateFields).forEach((key: any) => {
      state[key] = initialStateFields[key];
    });
  },

  [paymentStatus.mutations.SET_PAYMENT_STATUS_LIST]: (
    state,
    states: Array<PaymentStatus>
  ) => {
    const paymentStatuses: Array<PaymentStatus> = states;

    state.paymentStatusList = paymentStatuses;
  },
};

const actions: ActionTree<PaymentStatusState, RootState> = {
  [paymentStatus.actions.PAYMENT_STATUS_LIST]: (
    { commit, }
  ) => {
    return new Promise((resolve, reject) => {
      httpCommpix
        .get('/payment-status')
        .then((res: AxiosResponse) => {
          commit(
            paymentStatus.mutations.SET_PAYMENT_STATUS_LIST,
            res.data
          );
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
